// Search parameters of the chat: malformed values are dropped, not fatal.
import { z } from "zod";
import type { ChatSearch } from "../context";

const Schema = z.object({
  agent: z
    .string()
    .regex(/^[a-z0-9](?:[-a-z0-9]{0,61}[a-z0-9])?$/)
    .optional()
    .catch(undefined),
  conversation: z.uuid().optional().catch(undefined),
});

/** The search without its undefined entries, so the URL never shows them. */
export const cleanSearch = (search: Record<string, unknown>): ChatSearch =>
  Object.fromEntries(
    Object.entries(search).filter(([, value]) => value !== undefined),
  ) as ChatSearch;

export const validateChatSearch = (raw: Record<string, unknown>): ChatSearch =>
  cleanSearch(Schema.parse(raw));
